export default __webpack_public_path__ + "static/media/81_photo.820bd067.jpg";